import { FilterationCriteria } from "projects/shared/models/criteria/FilterationCriteria";

export class MediaHubFilterationCriteria extends FilterationCriteria {
  containsStringValue: string;
  mediaType: any[];
  isSocial: any;
  isChild: any;
  //cityId?: number;

  constructor(data?: MediaHubFilterationCriteria) {
    super();
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
}
